import CardCategory from './CardCategory';

export default CardCategory;
